/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */

import { LinkedLinkProps, PagePath, PathMap, QueryType } from 'shared-definitions/types'

export class LinkBuilder<PathSite extends PagePath, PathApi extends PagePath> {
  private readonly _appUrl: string
  private readonly _useTrailingSlash: boolean
  private readonly _pathMap: PathMap<PathSite | PathApi>

  constructor(pathMap: PathMap<PathSite | PathApi>, appUrl: string, useTrailingSlash: boolean) {
    this._appUrl = appUrl
    this._useTrailingSlash = useTrailingSlash
    this._pathMap = pathMap
  }

  public buildSiteLink(path: PathSite): LinkedLinkProps {
    return { href: this._build(path) }
  }

  public buildApiLink(path: PathApi, ts?: number): string {
    const tPath = path
    if (ts) {
      if ('query' in tPath) {
        tPath.query = {
          ...tPath.query,
          ts,
        }
      } else {
        tPath.query = { ts }
      }
    }

    return this._build(tPath)
  }

  public linkBuilder(
    base: string,
    params?: Record<string, string>,
    query?: QueryType,
    hash?: string
  ): string {
    let resultLink = base
    if (params) {
      for (const param in params) {
        if (!Object.prototype.hasOwnProperty.call(params, param)) {
          continue
        }
        resultLink = resultLink.replace(`[${param}]`, params[param])
      }
    }

    if (this._useTrailingSlash && resultLink.slice(-1) !== '/') {
      resultLink += '/'
    }

    if (query) {
      resultLink += '?' + stringify(query)
    }

    if (hash) {
      resultLink += `#${hash}`
    }

    return resultLink
  }

  private _build(path: PathSite | PathApi): string {
    return (
      this._appUrl + this.linkBuilder(this._pathMap[path.path], path.params, path.query, path.hash)
    )
  }
}

function stringify(input: QueryType): string {
  const result: string[] = []
  for (const key in input) {
    const val = input[key]
    if (Array.isArray(val)) {
      for (let i = 0; i < val.length; i++) {
        result.push(`${key}[${i}]=${encodeURI(val[i] as string)}`)
      }
    } else {
      result.push(`${key}=${encodeURI(val as string)}`)
    }
  }
  return result.join('&')
}
